import * as React from "react";
import MapGL, { Marker } from '@urbica/react-map-gl';
import * as MapboxGl from "mapbox-gl";
import 'mapbox-gl/dist/mapbox-gl.css';
var token = "pk.eyJ1IjoiYWRhbXJvY2tldG1ha2VycyIsImEiOiJja2ZpMW1mZmUwNDFtMnNuNGcxZ3pseWVjIn0.dEXchCY-vGztUFGvfMfzMQ";
export var MapContainer = function MapContainer(_ref) {
  var businesses = _ref.businesses;
  var map = React.useRef(null);
  React.useEffect(function () {
    if (map.current) {
      var locs = businesses.map(function (b) {
        return [b.location.longitude, b.location.latitude];
      });
      var bounds = new MapboxGl.LngLatBounds();
      locs.map(function (l) {
        return bounds.extend(l);
      });
      var m = map.current.getMap();
      m.fitBounds(bounds, {
        padding: 50
      });
    }
  }, [map]);

  var _React$useState = React.useState({
    latitude: 51.3811,
    longitude: -2.3590,
    zoom: 15
  }),
      viewport = _React$useState[0],
      setViewport = _React$useState[1];

  return /*#__PURE__*/React.createElement(MapGL, {
    ref: map,
    style: {
      width: '100%',
      height: '100%'
    },
    mapStyle: "mapbox://styles/mapbox/light-v9",
    accessToken: token,
    latitude: viewport.latitude,
    longitude: viewport.longitude,
    zoom: viewport.zoom,
    onViewportChange: setViewport
  }, businesses.map(function (b) {
    return /*#__PURE__*/React.createElement(Marker, {
      key: b.name,
      longitude: b.location.longitude,
      latitude: b.location.latitude
    }, /*#__PURE__*/React.createElement("a", {
      title: b.name,
      href: b.url,
      target: "_blank",
      className: "map-marker"
    }, /*#__PURE__*/React.createElement("img", {
      src: require('../assets/marker.svg')
    })));
  }));
};